export const AGGREGATION_PRICE = {
    MIN: 'min',
    MAX: 'max',
    AVG: 'avg'
}